import data from '@/services/data.service';

class FolderService {
  async getFolders() {
    return data.get('folders');
  }

  async createFolder(folder) {
    return data.post('folders', folder);
  }

  async updateFolder(folder) {
    return data.patch(`folders/${folder.id}`, folder);
  }

  async deleteFolder(folderId) {
    return data.delete(`folders/${folderId}`);
  }
}

export default new FolderService();
